import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const NewsLetter = () => {
  const logos = [
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784175/image_1705_zjk9oa.png', link: 'https://plofoundation.org/' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784350/image_1711_gfxdhn.png', link: 'https://www.nnfu.org.na/' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784276/image_1758_i9lydb.png', link: 'https://www.partnersforcare.org/ourprograms' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784351/image_1623_fwuqqw.png', link: 'https://4-bm.africa/' },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1526_k5t6wh.png',
      link: 'https://www.myhustle.africa',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784175/image_1709_fftpry.png',
      link: 'https://mawlr.gov.na/ ',
    },
  ];

  return (
    <div className="px-4 md:px-[7rem] mb-5 md:mb-10">
      <div className="w-full bg-[#2E453D]/90 rounded-b-[5px] flex flex-col items-center justify-center text-center px-4 py-6 md:py-10">
        <h1 className="text-white md:text-lg text-xs max-w-4xl leading-snug">
          Empowering farmers through trusted <span className="text-[#FDBD26]">partnerships</span> that support sustainable agribusiness
        </h1>

        {/* Swiper Logo Carousel */}
        <div className="w-full mt-4 md:mt-8">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            breakpoints={{
              640: { slidesPerView: 4 },
              768: { slidesPerView: 5},
              1024: { slidesPerView: 5 },
            }}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop
          >
            {logos.map((logo, idx) => (
              <SwiperSlide key={idx} className="flex justify-center items-center">
                <a href={logo.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={logo.src}
                    alt={`Logo ${idx + 1}`}
                    className="h-6 sm:h-10 md:h-20 object-contain"
                  />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
